import Svg, { Path, type SvgProps } from 'react-native-svg'

export function ChevronLeft(props: SvgProps & { size?: number }) {
  const size = props.size ? props.size : 16
  return (
    <Svg width={size} height={size} viewBox="0 0 16 16" fill="none" {...props}>
      <Path
        d="M10 4L6.20974 7.5286C5.93009 7.78894 5.93009 8.21106 6.20974 8.4714L10 12"
        stroke={props.stroke || (props.color ?? 'black')}
        strokeWidth={props.strokeWidth ?? '1.5'}
        strokeLinecap="round"
      />
    </Svg>
  )
}
